import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';

import {
  CellContext,
  ColorComponent,
  ColorOptions,
  GridData,
  TextCellConfig,
} from '../../../models';
import { GridCellContentAlignment } from '../../../enums';

@Component({
  selector: 'app-text-edit',
  templateUrl: './text-edit.component.html',
  styleUrls: ['./text-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextEditComponent
  extends ColorComponent<GridData>
  implements OnInit
{
  @Input({ required: true }) context!: CellContext<GridData>;
  @ViewChild('input', { static: true }) inputRef!: ElementRef;

  infinity = Infinity;
  GridCellContentAlignment = GridCellContentAlignment;
  dataTestId: string;

  renderer = inject(Renderer2);

  ngOnInit(): void {
    this.dataTestId = this.getDataTestId();
    this.renderer.setAttribute(
      this.inputRef?.nativeElement,
      'data-testId',
      this.dataTestId
    );
  }

  get config(): TextCellConfig {
    return this.context.config as TextCellConfig;
  }

  protected get contextColorOptions(): ColorOptions {
    return this.config.colorOptions;
  }

  @HostListener('keydown.shift.+', ['$event'])
  stopEventPropagation(event: KeyboardEvent): void {
    event.stopPropagation();
  }

  onFocusOut(): void {
    if (!this.config?.options?.allowSpace) {
      // The allowNullValue check is needed for the below scenario.
      // If a TextEditComponent is used for any cell we need to set the value to null
      // in case an empty string is provided, otherwise it will cause the row not to be deleted when saving if all
      // cell values are empty in offline mode. Thats because empty string is accounted for as a value

      this.context.data[this.context.column.columnDef] === '' &&
      this.config?.options?.allowNullValue
        ? (this.context.data[this.context.column.columnDef] = null)
        : (this.context.data[this.context.column.columnDef] =
            this.context.data[this.context.column.columnDef]?.trim());
    }
  }

  private getDataTestId(): string {
    return (
      'edit-' + this.context.column.header.name + '-' + this.context.row.index
    );
  }
}
